<template>
    <div v-if="show" class="colorPicker" :style="`background-color: ${color}`">
    </div>
</template>

<script>
export default {
  name: 'AbstractTheme',
  props: {
    color: String,
    name: String,
    misc: Object,
    show: Boolean,
  },
  created () {
    console.log('AT:', this.name)
  },

}
</script>

<style scoped>
    .colorPicker {
        float:left;
        padding: 3px;
        margin: 5px;
        width: 22px;
        height: 22px;
        font-size: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/theme/AbstractTheme.vue